(async () => {
    const { Core } = await importModule('Core');
    const { 
        $hide,
        $show 
    } = await importModule('Utils');

    const FAILSAFE_MS = 10000;

    customElements.define('page-spinner', class extends Core {

        subscriptions = {
            'spinner:show': '_onShow',
            'spinner:hide': '_onHide'
        }

        render() {
            this.subscribe('spinner:show', { global: true });
            this.subscribe('spinner:hide', { global: true });
        }
        
        _onShow() {
            $show(this);
            // Failsafe: this element uses backdrop-filter: blur(), a genuinely
            // expensive property to keep compositing. If whatever is supposed
            // to fire 'spinner:hide' ever fails to do so, this makes sure the
            // spinner (and its blur) can't stay stuck on-screen indefinitely.
            clearTimeout(this._failsafeTimer);
            this._failsafeTimer = setTimeout(() => {
                $hide(this);
            }, FAILSAFE_MS);
        }

        _onHide() {
            clearTimeout(this._failsafeTimer);
            $hide(this);
        }
    })
})();